/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reduxFetch from 'react-redux-fetch';
import { compose } from 'redux';
import apiRoutes from '../../../app/api/routes';

const communityText = ComposedComponent => {
  class CommunityText extends Component {
    componentDidMount() {
      const { language, communityTag, dispatchCommunityTextGet } = this.props;

      dispatchCommunityTextGet(communityTag, language);
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  CommunityText.propTypes = {
    dispatchCommunityTextGet: PropTypes.func.isRequired,
    communityTag: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
  };

  return compose(
    reduxFetch([
      {
        resource: 'communityText',
        method: 'get',
        request: (communityTag, language) => ({
          url: apiRoutes.communityText(communityTag, language),
        }),
      },
    ])
  )(CommunityText);
};

export default communityText;
